export const FieldError: React.FC<{error?: string}> = ({error}) => {
  if (!error) return null;

  return <p className="text-error text-sm mt-1">{error}</p>;
};
